var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "a-row",
        { attrs: { gutter: [20, 20] } },
        [
          _c("a-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "table-operator" }),
          ]),
        ],
        1
      ),
      _c(
        "a-row",
        [
          _c(
            "a-col",
            { attrs: { span: 24 } },
            [
              _c("TableList", {
                attrs: {
                  rowKey: "id",
                  bordered: "",
                  loading: _vm.loading,
                  columns: _vm.columns,
                  tableData: _vm.dataSource,
                  scroll: false,
                  pagination: _vm.ipagination,
                  rowSelection: {
                    selectedRowKeys: _vm.selectedRowKeys,
                    onChange: _vm.onSelectChange,
                  },
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "action",
                    fn: function ({ record }) {
                      return _c(
                        "div",
                        { staticStyle: { cursor: "pointer" } },
                        [
                          _c(
                            "a-popconfirm",
                            {
                              attrs: { title: "确定删除吗?" },
                              on: {
                                confirm: () => _vm.handleDelete(record.id),
                              },
                            },
                            [_c("a", [_vm._v("删除")])]
                          ),
                          _c("a-divider", { attrs: { type: "vertical" } }),
                          _c(
                            "a-popconfirm",
                            {
                              attrs: { title: "确定推送文章吗?" },
                              on: { confirm: () => _vm.notification(record) },
                            },
                            [_c("a", [_vm._v("推送")])]
                          ),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showViewPhoto
        ? _c("ViewPhoto", {
            ref: "viewPhotoRef",
            on: {
              close: function ($event) {
                _vm.showViewPhoto = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }